import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { INFT } from '../../types/INFT'

import PuffLoader from 'react-spinners/PuffLoader'
import Card from '../Card/Card'

interface Props {
  nfts: Array<INFT>
  isLoading: boolean,
}

const NFTShowcase: React.FC<Props> = (props) => {
  const [swiper, setSwiper]: any = useState<Swiper>()
  return (
    <div className={`slider-wrap ${props.isLoading ? 'is-loading' : ''}`}>
      {props.nfts.length > 1 && (
        <div className="previous" onClick={() => swiper.slidePrev()}>
          <i className="fa-light fa-chevron-left"></i>
        </div>
      )}
      {props.isLoading ? (
        <PuffLoader />
      ) : (
        <>
          {props.nfts.length > 0 && (
            <Swiper
              onSwiper={(swiper: any) => setSwiper(swiper)}
              slidesPerView={1}>
              {props.nfts.length > 0 &&
                props.nfts.map((nft: any, index: number) => {
                  return (
                    <React.Fragment key={nft.tokenId + '-' + index}>
                      <SwiperSlide key={nft.tokenId + '-' + index}>
                        <Card nft={nft} />
                      </SwiperSlide>
                    </React.Fragment>
                  )
                })}
            </Swiper>
          )}
          {props.nfts.length <= 0 && (
            <Swiper
              onSwiper={(swiper: any) => setSwiper(swiper)}
              slidesPerView={1}>
              <SwiperSlide>
                <Card nft={{ }} />
              </SwiperSlide>
            </Swiper>
          )}
        </>
      )}
      {props.nfts.length > 1 && (
        <div className="next" onClick={() => swiper.slideNext()}>
          <i className="fa-light fa-chevron-right"></i>
        </div>
      )}
    </div>
  )
}

export default NFTShowcase
